import { SPATEM } from '_lib/api';
import { SpatemActivityStatus } from './spatemsTypes';

/**
 * Check if a SPATEM is active based on the latest update timestamp.
 * A SPATEM is considered active if the last update was within the last 8 seconds.
 * @param spatem - The SPATEM object to check
 * @returns SpatemActivityStatus.ACTIVE if updated within 8 seconds, otherwise INACTIVE
 */
export const getSpatemActivityStatus = (spatem: SPATEM): SpatemActivityStatus => {
  if (!spatem?.updated_at) {
    return SpatemActivityStatus.INACTIVE;
  }

  try {
    const updatedAt = new Date(spatem.updated_at);
    const now = new Date();
    const diffInSeconds = (now.getTime() - updatedAt.getTime()) / 1000;

    return diffInSeconds <= 8 ? SpatemActivityStatus.ACTIVE : SpatemActivityStatus.INACTIVE;
  } catch {
    return SpatemActivityStatus.INACTIVE;
  }
};

